module.exports = __webpack_public_path__ + "static/media/build-768w.c3864af6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/MU/assets/build-768w.jpg
// module id = 179
// module chunks = 0